"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorTransform = exports.ApiRequestError = void 0;
class ApiRequestError extends Error {
    constructor(message, data) {
        super(message);
        this.data = data || {};
    }
}
exports.ApiRequestError = ApiRequestError;
const buildApiError = (error) => {
    if (!error || !error.response)
        return {
            message: 'Unknown API error',
            data: { status: -1, statusText: 'UNKNOWN STATUS', headers: {} }
        };
    const { status, statusText, data: body } = error.response;
    const { headers, method, url } = error.response.config;
    const message = `${status}: ${statusText}`;
    const data = { status, statusText, headers, method, url, body };
    return { message, data };
};
const errorTransform = (error) => {
    if (error && error.response) {
        const { message, data } = buildApiError(error);
        throw new ApiRequestError(message, data);
    }
    throw error;
};
exports.errorTransform = errorTransform;
//# sourceMappingURL=errors.js.map